export default {
  modalName: {
    id: 'insurance_backup_plus_drawer_name',
    defaultMessage: 'BackUp+ protection',
  },
  warranty: {
    id: 'insurance_backup_plus_drawer_table_warranty',
    defaultMessage: 'Warranty',
  },
  comparisonTable1: {
    id: 'insurance_backup_plus_drawer_table_benefit1',
    defaultMessage: 'Defects covered',
  },
  comparisonTable2: {
    id: 'insurance_backup_plus_drawer_table_benefit2',
    defaultMessage: 'Drops, spills, cracks',
  },
  comparisonTable3: {
    id: 'insurance_backup_plus_drawer_table_benefit3',
    defaultMessage: 'Free battery replacement after 12 months',
  },
  comparisonTable4: {
    id: 'insurance_backup_plus_drawer_table_benefit4',
    defaultMessage: 'Refund if we can’t fix it',
  },
  howToUseBackupPlus: {
    id: 'insurance_backup_plus_drawer_how_to_use_backup_plus',
    defaultMessage: 'How to use BackUp+',
  },
  howToUseBackupPlusTitle1: {
    id: 'insurance_backup_plus_drawer_how_to_use_backup_plus_title1',
    defaultMessage: '3-day turnaround',
  },
  howToUseBackupPlusContent1: {
    id: 'insurance_backup_plus_drawer_how_to_use_backup_plus_content1',
    defaultMessage:
      'Send your device in for repair and get it back within 3 business days.',
  },
  howToUseBackupPlusTitle2: {
    id: 'insurance_backup_plus_drawer_how_to_use_backup_plus_title2',
    defaultMessage: 'Talk with a real human',
  },
  howToUseBackupPlusContent2: {
    id: 'insurance_backup_plus_drawer_how_to_use_backup_plus_content2',
    defaultMessage: 'No chat bots here. You’re in good hands with our experts.',
  },
  howToUseBackupPlusTitle3: {
    id: 'insurance_backup_plus_drawer_how_to_use_backup_plus_title3',
    defaultMessage: 'Unlimited repairs',
  },
  howToUseBackupPlusContent3: {
    id: 'insurance_backup_plus_drawer_how_to_use_backup_plus_content3',
    defaultMessage: 'Coverage for drops, spills, and other accidental damage.',
  },
  howToUseBackupPlusTitle4: {
    id: 'insurance_backup_plus_drawer_how_to_use_backup_plus_title4',
    defaultMessage: 'Easy replacement',
  },
  howToUseBackupPlusContent4: {
    id: 'insurance_backup_plus_drawer_how_to_use_backup_plus_content4',
    defaultMessage:
      'If your device can’t be repaired, get a Back Market credit for your next one.',
  },
}
